module.exports = __webpack_public_path__ + "img/coming-soon-dark.ab1f4015.svg";